
import { Card } from "@/components/ui/card";
import { Contractor } from "@/types/contractor";
import { ContractorImage } from "./contractor/ContractorImage";
import { ContractorDetails } from "./contractor/ContractorDetails";
import { getPlaceholderImage } from "@/utils/imageUtils";
import { cleanSlug, normalizeServiceType, normalizeContractorName } from "@/utils/urlUtils";

interface ContractorCardProps {
  contractor: Contractor;
  viewMode?: "grid" | "list";
}

export const ContractorCard = ({ contractor, viewMode = "grid" }: ContractorCardProps) => {
  // Prioritize logo_link over gmb_link
  const imageUrl = contractor.logo_link || contractor.gmb_link || getPlaceholderImage(contractor.service_type);
  
  // Normalize contractor name (e.g., rename "Edmond Tree Service" to "Redbud Tree Service")
  const displayName = normalizeContractorName(contractor.name);
  
  // Generate the URL-friendly service type (ensure it's properly formatted)
  const serviceType = contractor.service_type.toLowerCase().replace(/\s+/g, '-');
  
  // Generate the URL-friendly location
  const location = contractor.location?.toLowerCase() || 'oklahoma-city';
  
  // Generate the URL-friendly business name, clean any trailing commas
  const businessSlug = cleanSlug(contractor.slug || contractor.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''));
  
  // Construct the new URL structure
  const contractorPageUrl = `/${location}/${serviceType}/${businessSlug}`;
  
  console.log('Rendering contractor card:', {
    name: contractor.name,
    displayName,
    serviceType: contractor.service_type,
    logoLink: contractor.logo_link,
    gmbLink: contractor.gmb_link,
    finalImageUrl: imageUrl,
    featured: contractor.featured,
    pageUrl: contractorPageUrl
  });

  return (
    <Card 
      className={`overflow-hidden transition-all duration-300 hover:shadow-lg hover:scale-[1.02] ${
        viewMode === "grid" ? 'flex flex-col' : 'flex flex-row'
      } ${contractor.featured ? 'ring-2 ring-green-500/20' : ''}`}
    >
      <ContractorImage
        imageUrl={imageUrl}
        name={displayName}
        serviceType={contractor.service_type}
        pageUrl={contractorPageUrl}
        viewMode={viewMode}
      />
      <ContractorDetails
        name={displayName}
        serviceType={contractor.service_type}
        rating={contractor.rating}
        reviewCount={contractor.review_count}
        address={contractor.address}
        phone={contractor.phone}
        website={contractor.website}
        pageUrl={contractorPageUrl}
        viewMode={viewMode}
        featured={contractor.featured}
      />
    </Card>
  );
};
